module.exports = __webpack_public_path__ + "static/media/robot-corn-hacking-laptop.df54445a.jpg";